// Dependencies
import React, { Component, PropTypes } from 'react';
import RaisedButton from '../tc-ui/raised-button-with-loader';

class SignInForm extends Component {

  onChange = (event) => {
    if (this.props.onChange) this.props.onChange(event);
  };

  render() {
    const submitButton = (() => {
      if (this.props.sending) return <RaisedButton data-cy="signin-loading" style={{ width: '100%' }} label="Loading..." className={'signin-button loader'} disabled/>;
      return <RaisedButton style={{ width: '100%' }} secondary onClick={this.props.onSubmit} label="Log in" className={'signin-button-clicker'} data-cy={'signin-button-clicker'}/>;
    })();

    return (
      <div>
        <h2 className="signin-header">Log In</h2>
        <form onChange={this.onChange} onSubmit={this.props.onSubmit}>
          {this.props.children}
          {submitButton}
        </form>
      </div>
    );
  }
}

SignInForm.propTypes = {
  onChange: PropTypes.func,
  sending: PropTypes.bool,
  children: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default SignInForm;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/signin/signin-form.jsx